import React, { useEffect, useState } from 'react';
import * as R from 'ramda';
import { useDispatch, useSelector } from 'react-redux';
import { ServicesEdit } from './../_common/servicesEdit';
import { CommonServices } from '../../../constants/utils/connectionTypes';
import { getProgress } from '../../anticipa/_common/serviceNavbar/calculateProgress';
import * as Loadings from '../../../constants/loadings/user';
import { addUserService } from '../../../actions/user-api';
import { LoadingState } from '../../../_common/loadingState';

export const Communes = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user);
    const [selectedService, setSelectedService] = useState(undefined);
    const servicesData = useSelector(state => state.services);
    const [selectedServices, setSelectedServices] = useState([]);

    useEffect(() => {
        if (!R.isNil(user) && !R.isNil(user) && !R.isNil(user.services) && user.services !== []) {
            setSelectedServices(user.services);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!R.isNil(user) && !R.isNil(user.services) && user.services.length > 0) {
            setSelectedServices(user.services);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user.services]);

    function addOrRemove(option) {
        let tmpSelected = JSON.parse(JSON.stringify(selectedServices));
        if (tmpSelected.findIndex(o => o.connectionType === option.connectionType) === -1) {
            tmpSelected.push(option);
            dispatch(addUserService(user.user, { connectionType: option.connectionType }));
        }
        setSelectedServices(tmpSelected);
    }

    if (user.isLoading.includes(Loadings.FETCH_SERVICES)) {
        return <LoadingState />;
    }


    return (
        <article className="view-calc my-4">
            {/* <div className="auto-view py-3 pb-lg-0"> */}
                <div className="container-fluid">
                    <form className="grid-sm grid-sm-min grid-lg-demarche">
                        {
                            R.sortWith([R.ascend(R.prop('title'))])(Object.entries(CommonServices).map(entry => entry[1])).map((srv, index) => {
                                let progress = getProgress(servicesData.serviceData, srv.connectionType);
                                return (
                                    <div key={index} className="form-group col col-lg-3 col-xl-2" data-toggle="modal" data-target="#servicesEdit" onClick={(e) => {
                                        e.preventDefault();
                                        setSelectedService(srv.connectionType);
                                        addOrRemove(srv);
                                    }}>
                                        <div className={"card card-body text-center picker-card" + (selectedServices.findIndex(s => s.connectionType === srv.connectionType) !== -1 ? ' active' : '')}>
                                            <img className="img-fluid mx-auto mt-auto mb-2 h-6 py-1" src={srv.icon} alt={srv.title} />
                                            <h3 className={"h6 text-uppercase font-weight-bolder container-slim" + (progress === 100 ? ' m-auto' : ' mx-auto mt-auto')}>{srv.title}</h3>
                                            <p className={"h5 mt-auto lh-copy" + (progress === 100 ? ' o-0' : '')}>À compléter</p>
                                            <div className={"progress position-relative w-100 text-center h-4 rounded-max align-items-center mt-auto mb-0" + (progress === 100 ? ' bg-white' : ' bg-common 0')}>
                                                <div className={"progress-bar h-100 rounded-inherit" + (progress === 100 ? ' bg-success o-20' : ' gradient-prime o-50')} style={{ width: `${progress}%` }} role="progressbar"></div>
                                                <div className={"d-flex position-absolute m-auto justify-content-center w-100 font-weight-bolder" + (progress === 100 ? ' text-success' : ' o-80')} role="progressbar">{progress}%</div>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                    </form>
                </div>
            {/* </div> */}
            <ServicesEdit selectedService={selectedService} setSelectedService={setSelectedService} />
        </article>
    );
};